module.exports = __webpack_public_path__ + "static/media/imagem7.442e3cf1.jpeg";